import { render, staticRenderFns } from "./ProjectSettingsSetup.vue?vue&type=template&id=9ada3882&scoped=true&"
import script from "./ProjectSettingsSetup.vue?vue&type=script&lang=js&"
export * from "./ProjectSettingsSetup.vue?vue&type=script&lang=js&"
import style0 from "./ProjectSettingsSetup.vue?vue&type=style&index=0&id=9ada3882&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ada3882",
  null
  
)

export default component.exports